<template>
  <div id="Tab2">
    <div
      v-if="
        ValidationTriggered.validation &&
          ValidationTriggered.validTabs[1].value &&
          ValidationTriggered.validTabs[1].name
      "
      class="mb-3"
    >
      <Error
        variant="no-border"
        :message="this.resources[ValidationTriggered.validTabs[1].name]"
      />
    </div>
    <SectionTitle
      :has-line="true"
      content="I. Información Médica o de Especialistas (Fechas de evaluaciones realizadas y servicios que recibe)"
    />

    <!-- Table DIV 1 -->
    <div class="container-fluid mb-4 table-W mt-4">
      <div class="shadow">
        <div class="row headboard">
          <div class="col-12 text-center bold">
            <span>Evaluaciones Realizadas y Servicios</span>
          </div>
        </div>
      </div>
      <div class="row bg-gray">
        <div class="col-2 pt-1 pl-5">
          <span>Visual</span>
          <br />
          <span class="regular">{{ visualInfo.evaluationDateString }}</span>
        </div>
        <div class="col-2 pt-1">
          <button
            v-if="visualInfo.documentAttachmentIds != null"
            title="Descargar documento de la evaluación"
            class="btn btn-outline-success history-btn pt-1"
            @click="downloadEvaluation(visualInfo.documentAttachmentIds)"
          >
            <i class="fas fa-file-download" />
            <span>Descargar</span>
          </button>
        </div>
        <div class="col table-badge-text mt-2">
          <ValidationObserver
            ref="visualAcuitiesValidator"
            v-slot="{ invalid }"
          >
            <ul>
              <li>
                <span class="table-badge-span">Agudezas visuales:</span>
                <div class="form-input">
                  <ValidationProvider
                    :rules="
                      `${
                        ValidationTriggered.validation &&
                        generalMedicalInformation.isUsingMedsFlag &&
                        !canEditVisualInfo()
                          ? 'required'
                          : ''
                      }`
                    "
                    immediate
                    name="ODCC"
                  >
                    <input
                      v-model="visualInfo.odWithCorrection"
                      type="text"
                      maxlength="8"
                      :disabled="canEditVisualInfo()"
                    />
                  </ValidationProvider>
                  <label>OD</label>
                </div>
                <div class="form-input">
                  <ValidationProvider
                    :rules="
                      `${
                        ValidationTriggered.validation &&
                        generalMedicalInformation.isUsingMedsFlag &&
                        !canEditVisualInfo()
                          ? 'required'
                          : ''
                      }`
                    "
                    immediate
                    name="OSCC"
                  >
                    <input
                      v-model="visualInfo.osWithCorrection"
                      type="text"
                      maxlength="8"
                      :disabled="canEditVisualInfo()"
                    />
                  </ValidationProvider>
                  <label>OS (con corrección)</label>
                </div>
              </li>
              <li>
                <span class="table-badge-span" />
                <div class="form-input">
                  <ValidationProvider
                    :rules="
                      `${
                        ValidationTriggered.validation &&
                        generalMedicalInformation.isUsingMedsFlag &&
                        !canEditVisualInfo()
                          ? 'required'
                          : ''
                      }`
                    "
                    immediate
                    name="ODSC"
                  >
                    <input
                      v-model="visualInfo.odWithoutCorrection"
                      type="text"
                      maxlength="8"
                      :disabled="canEditVisualInfo()"
                    />
                  </ValidationProvider>
                  <label>OD</label>
                </div>
                <div class="form-input">
                  <ValidationProvider
                    :rules="
                      `${
                        ValidationTriggered.validation &&
                        generalMedicalInformation.isUsingMedsFlag &&
                        !canEditVisualInfo()
                          ? 'required'
                          : ''
                      }`
                    "
                    immediate
                    name="OSSC"
                  >
                    <input
                      v-model="visualInfo.osWithoutCorrection"
                      type="text"
                      maxlength="8"
                      :disabled="canEditVisualInfo()"
                    />
                  </ValidationProvider>
                  <label>OS (sin corrección)</label>
                </div>
              </li>
            </ul>
            <Error
              v-if="invalid"
              variant="no-border"
              :message="'Favor de completar las Agudezas visuales'"
            />
          </ValidationObserver>
        </div>
      </div>

      <div class="divider" />
      <div
        v-for="(executedSrvicesandEvaluation,
        index) in executedServicesAndEvaluations"
        :key="executedSrvicesandEvaluation.disciplineTypeCd"
      >
        <div class="row" :class="{ 'bg-gray': index % 2 }">
          <div class="col-4 pt-1">
            <div class="row">
              <div class="col-6">
                <span>{{ executedSrvicesandEvaluation.disciplineName }}</span>
                <br />
                <span class="regular">
                  {{ executedSrvicesandEvaluation.evaluationDateString }}
                </span>
              </div>
              <div class="col-6">
                <button
                  v-if="
                    executedSrvicesandEvaluation.documentAttachmentIds != null
                  "
                  title="Descargar documento de la evaluación"
                  class="btn btn-outline-success history-btn pt-1"
                  @click="
                    downloadEvaluation(
                      executedSrvicesandEvaluation.documentAttachmentIds
                    )
                  "
                >
                  <i class="fas fa-file-download" />
                  <span>&nbsp;&nbsp;Descargar</span>
                </button>
              </div>
            </div>
            <Error
              v-if="
                !atCompletedFlag &&
                  executedSrvicesandEvaluation.analysisServiceId != null &&
                  executedSrvicesandEvaluation.frequencyName == null
              "
              is-alert-mode
              message="El detalle del servicio no ha sido documentado en el tab VIII.(191303)"
              class="mt-1"
            />
          </div>
          <div class="col-4 pt-1">
            <span>Frecuencia:</span>
            <span class="regular">
              {{ executedSrvicesandEvaluation.frequencyName }}
            </span>
            <br />
            <span>Modalidad:</span>
            <span class="regular">
              {{ executedSrvicesandEvaluation.modalityName }}
            </span>
          </div>

          <div class="col-4 pt-1">
            <span>Duración:</span>
            <span class="regular">
              {{ executedSrvicesandEvaluation.durationName }}
            </span>
            <br />
            <span>Admisión:</span>
            <span class="regular">
              {{ executedSrvicesandEvaluation.admissionDateString }}
            </span>
          </div>
        </div>
        <div class="divider" />
      </div>
    </div>
    <!-- END Table DIV 1 -->

    <!-- OTROS SERVICIOS -->

    <div class="row">
      <div class="col-12">
        <SectionTitle :has-line="false" content="Otros Servicios" />
        <div class="dropdown-divider mt-0 pb-2 ml-3" />
      </div>
      <div class="col-6 pr-1">
        <!-- Table -->
        <div class="container-table-striped">
          <div class="table-hover">
            <table class="table content-table-striped table-striped mb-5">
              <thead>
                <tr class="row global-thead-dark thead-property">
                  <th class="col-4 pl-3 py-3 bold">
                    <span class="ml-1">Evaluaciones</span>
                  </th>
                  <th class="col-2 pl-3 py-3 bold">
                    <span class="d-flex text-center" />
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="notExecutedEvaluation in notExecutedEvaluations"
                  :key="notExecutedEvaluation.rowNumber"
                  class="row"
                >
                  <td class="col-8">
                    <p>{{ notExecutedEvaluation.name }}</p>
                  </td>
                  <td class="col-4 text-right">
                    <button
                      v-if="notExecutedEvaluation.documentAttachmentIds != null"
                      class="btn btn-outline-success history-btn pt-1"
                      title="Descargar documento de la evaluación"
                      @click="
                        downloadEvaluation(
                          notExecutedEvaluation.documentAttachmentIds
                        )
                      "
                    >
                      <i class="fas fa-file-download" />
                      <span>&nbsp;&nbsp;Descargar</span>
                    </button>
                  </td>
                </tr>
                <tr class="row">
                  <td class="col-12 text-center bg-gray">
                    <CustomAddRemoveListPopup
                      :object-key="'rowNumber'"
                      :object-description="'name'"
                      :initial-show-state="false"
                      :btn-classes="'btn bg-light-white btn-addFile'"
                      :added-column-description="'Evaluaciones Seleccionadas'"
                      :removed-column-description="'Evaluaciones Disponibles'"
                      :added-list="notExecutedEvaluations"
                      :removed-list="avalaibleEvaluations"
                      :disabled-predicate="evaluationsPredicateDisabled"
                      @updated="handleEvaluationsUpdated"
                    >
                      <!-- This slot is the content rendered inside the button-->
                      <slot>
                        <i class="fas fa-file-plus" />
                        <span>
                          Presione aquí para añadir evaluaciones disponibles
                        </span>
                      </slot>
                    </CustomAddRemoveListPopup>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="col-6 pl-0">
        <!-- Table -->
        <div class="container-table-striped">
          <div class="table-hover">
            <span class="text-danger">
              {{
                validRecordEvaluation()
                  ? ''
                  : 'Las evaluaciones que recomiendan el servicio deben tener relación de record de evaluación y no de documento'
              }}
            </span>
            <table class="table content-table-striped table-striped mb-5">
              <thead>
                <tr class="row global-thead-dark thead-property">
                  <th class="col-4 pl-3 py-3">
                    <span class="ml-1 bold">Terapia</span>
                  </th>
                  <th class="col-2 pl-3 py-3">
                    <span class="d-flex text-center" />
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="notExecutedTherapy in notExecutedTherapies"
                  :key="notExecutedTherapy.analysisServiceId"
                  class="row"
                >
                  <td class="col-8">
                    <p>
                      <strong
                        :data-tooltip="
                          'Modalidad:' +
                            notExecutedTherapy.modalityName +
                            ' Frecuencia:' +
                            notExecutedTherapy.frequencyName +
                            ' Duración:' +
                            notExecutedTherapy.durationName
                        "
                      >
                        {{ notExecutedTherapy.analysisServiceName }}
                      </strong>
                    </p>
                  </td>
                </tr>
                <tr class="row">
                  <td class="col-12 text-center bg-gray">
                    <CustomAddRemoveListPopup
                      :object-key="'analysisServiceId'"
                      :object-description="'analysisServiceName'"
                      :initial-show-state="false"
                      :btn-classes="'btn bg-light-white btn-addFile'"
                      :added-column-description="'Terapias Seleccionadas'"
                      :removed-column-description="'Terapias Disponibles'"
                      :added-list="notExecutedTherapies"
                      :removed-list="avalaibleTherapies"
                      :title="'Selección de Terapias'"
                      @updated="handleTherapiesUpdated"
                    >
                      <!-- This slot is the content rendered inside the button-->
                      <slot>
                        <i class="fas fa-file-plus" />
                        <span>
                          Presione aquí para añadir terapias disponibles
                        </span>
                      </slot>
                    </CustomAddRemoveListPopup>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div v-if="IsVisiblegetRecentEvaluations()">
      <SectionTitle
        :has-line="false"
        content="Evaluaciones de Asistencia Tecnológica Año en Curso"
      />
      <div class="dropdown-divider mt-0 pb-2 ml-3" />
    </div>
    <template v-if="IsVisiblegetRecentEvaluations()">
      <RecentAtEvaluation
        ref="recentEvaluations"
        @getSelectedEvaluations="getSelectedEvaluations"
        @download="downloadEvaluation"
      />
    </template>

    <div class="additional-questions">
      <SectionTitle :has-line="false" content="Información Adicional" />
      <div class="dropdown-divider mt-0 pb-2 ml-3" />
      <form action>
        <div class="additional-questions-item">
          <strong>Otras consideraciones de salud:</strong>
          <div class="form-group">
            <div class="mb-3">
              <ValidationProvider
                v-slot="{ errors }"
                style="witdh:100%"
                :rules="`${ValidationTriggered.validation ? 'required' : ''}`"
                immediate
                name=" "
              >
                <CustomTextArea
                  id="otherHealthConsiderations"
                  v-model="generalMedicalInformation.otherHealthConsiderations"
                  style="width:100%"
                  :maxlength="maxchars"
                  :classes="['eq-field']"
                  :error="errors[0]"
                  :custom-error-msg.sync="errors[0]"
                />
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div class="additional-questions-item">
          <strong>Usa medicamentos:</strong>
          <div class="d-inline-flex">
            <div class="input-group">
              <input
                id="input1"
                v-model="generalMedicalInformation.isUsingMedsFlag"
                type="radio"
                class="hidden"
                name="inputs"
                :value="true"
              />
              <label class="entry" for="input1">
                <div class="circle" />
                <div class="entry-label">Si</div>
              </label>

              <input
                id="input2"
                v-model="generalMedicalInformation.isUsingMedsFlag"
                type="radio"
                class="hidden"
                name="inputs"
                :value="false"
              />
              <label class="entry" for="input2">
                <div class="circle" />
                <div class="entry-label">No</div>
              </label>
              <div class="highlight" />
            </div>
          </div>
        </div>
        <transition name="list">
          <div
            v-if="generalMedicalInformation.isUsingMedsFlag"
            class="additional-questions-item"
          >
            <div class="form-group">
              <div class=" mb-3">
                <ValidationProvider
                  v-slot="{ errors }"
                  :rules="
                    `${
                      ValidationTriggered.validation &&
                      generalMedicalInformation.isUsingMedsFlag
                        ? 'required'
                        : ''
                    }`
                  "
                  immediate
                  name=" "
                >
                  <CustomTextArea
                    id="academicAchievementComment"
                    v-model="generalMedicalInformation.medsUsedDescription"
                    label="Especifíque cuales:"
                    :maxlength="300"
                    :classes="['eq-field']"
                    :error="errors[0]"
                    :disabled="!generalMedicalInformation.isUsingMedsFlag"
                    :custom-error-msg.sync="errors[0]"
                  />
                </ValidationProvider>
              </div>
            </div>
          </div>
        </transition>
        <div class="additional-questions-item">
          <strong>Equipo de ayuda que utiliza el estudiante:</strong>

          <div class="form-group">
            <div class="input-group additional-check mb-3">
              <div v-for="equipment in equipments" :key="equipment.id">
                <input
                  :id="'chkb' + equipment.id"
                  type="checkbox"
                  class="option-input checkbox"
                  :value="equipment.id"
                  :disabled="atCompletedFlag"
                  :checked="equipment.selected"
                  @click="onCheck($event)"
                />
                <label :for="'chkb' + equipment.id">
                  <span>
                    <i class="ic-check" />
                  </span>
                  {{ equipment.spashortDescription }}
                </label>
              </div>
            </div>
            <div
              v-for="equipment in equipments"
              :key="equipment.id"
              class="additional-questions-item"
            >
              <div
                v-if="equipment.id == 5 && equipment.selected"
                class="form-group"
              >
                <div class="input-group mb-3">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :rules="
                      `${ValidationTriggered.validation ? 'required' : ''}`
                    "
                    immediate
                    name=" "
                    class="w-100"
                  >
                    <CustomTextArea
                      v-show="true"
                      id="otherEquipmnets"
                      v-model="equipment.comment"
                      style="width:100%"
                      :maxlength="maxchars"
                      :classes="['eq-field']"
                      :error="errors[0]"
                      :disabled="atCompletedFlag"
                      :show-char-count="false"
                    />
                  </ValidationProvider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import store from '@/store/index';
import alert from '@/mixin/alert.mixin';
// import Tabs from '@/utils/constants/at/atTabs.js';
import { SectionTitle } from '@/components/pei/shared';
import CustomTextArea from '@/components/common/CustomTextArea';
import RecentAtEvaluation from '@/components/at/recentAtEvaluations';
import CustomAddRemoveListPopup from '@/components/common/CustomAddRemoveListPopup';
import Error from '@/components/common/Error.vue';
import loading from '@/mixin/loading.mixin';
import atService from '@/services/pei/at';
import resourcesService from '@/services/resources.js';

export default {
  name: 'Tab2',
  components: {
    CustomTextArea,
    CustomAddRemoveListPopup,
    RecentAtEvaluation,
    SectionTitle,
    Error,
  },
  mixins: [loading, alert],
  data() {
    return {
      maxchars: 3000,
      requireAtEvaluation: store.getters.SelectPreEvalAnswer,
      peiId: store.getters.SelectedPei,
      Info: {},
      executedServicesAndEvaluations: [],
      visualInfo: {},
      notExecutedEvaluations: [],
      avalaibleEvaluations: [],
      notExecutedTherapies: [],
      avalaibleTherapies: [],
      equipments: {},
      generalMedicalInformation: { isUsingMedsFlag: true },
      selectedEvaluations: [],
      resources: [],
    };
  },
  methods: {
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        'R03200110',
        'R03200109',
        'R9260060',
      ]);
    },
    onCheck: function(e) {
      for (let i = 0; i <= this.equipments.length - 1; i++) {
        if (this.equipments[i].id == e.target.value) {
          this.equipments[i].selected = e.target.checked;
          if (e.target.value == 5) {
            this.oher = e.target.checked;
          }
        }
      }
    },
    getExecutedServiceandEvaluations() {
      this.$ApiGet(
        'api/atservice/executedserviceandevaluation?peiId=' + this.peiId
      ).then((res) => {
        if (res.data && res.data.length > 0) {
          this.executedServicesAndEvaluations = res.data.filter(
            (x) => !x.isVisual
          );
          this.visualInfo = res.data.find((x) => x.isVisual);
        }
      });
    },
    getNotExecutedEvaluation() {
      this.$ApiGet(
        'api/atservice/notexecutedevaluation?peiId=' +
          this.peiId +
          '&requireAtEvaluation=' +
          this.requireAtEvaluation
      ).then((res) => {
        this.notExecutedEvaluations = res.data;
      });
    },
    getNotExecutedtherapies() {
      this.$ApiGet(
        'api/atservice/notavailabletherapy?peiId=' + this.peiId
      ).then((res) => {
        this.notExecutedTherapies = res.data;
      });
    },
    getAvalaibletherapies() {
      this.$ApiGet('api/atservice/availabletherapy?peiId=' + this.peiId).then(
        (res) => {
          this.avalaibleTherapies = res.data;
        }
      );
    },
    getAvalaibleEvaluations() {
      this.$ApiGet('api/atservice/availablevaluation?peiId=' + this.peiId).then(
        (res) => {
          this.avalaibleEvaluations = res.data;
        }
      );
    },
    getEquipments() {
      this.$ApiGet(
        'api/atservice/getPeiAtserviceequipment?peiAtServiceId=' +
          this.peiAtServiceId
      ).then((res) => {
        this.equipments = res.data;
      });
    },
    getSelectedEvaluations(selectedEvaluations) {
      this.selectedEvaluations = selectedEvaluations;
    },
    getGeneralAtInformation() {
      this.$ApiGet(
        'api/atservice/getgeneralmedicalinformation?peiAtServiceId=' +
          this.peiAtServiceId
      ).then((res) => {
        this.generalMedicalInformation = res.data;
        if (this.generalMedicalInformation == null) {
          this.generalMedicalInformation = {
            otherHealthConsiderations: '',
            isUsingMedsFlag: false,
            medsUsedDescription: '',
          };
        } else {
          if (this.generalMedicalInformation.isUsingMedsFlag == null) {
            this.generalMedicalInformation.isUsingMedsFlag = false;
          }
        }
      });
    },
    async save() {
      if (this.peiAtServiceId === 0) {
        const createdAtServiceId = await atService.createAtService(
          store.getters.SelectedPei
        );

        if (createdAtServiceId > 0) {
          store.dispatch('setSelectedAt', createdAtServiceId);
          this.peiAtServiceId = createdAtServiceId;
        }
      }

      const detailMedicalInformationATDTO = {
        peiId: this.peiId,
        peiAtServiceId: this.peiAtServiceId,
        notExecutedEvaluations: this.notExecutedEvaluations,
        notExecutedTherapies: this.notExecutedTherapies,
        generalMedicalInformation: this.generalMedicalInformation,
        peiAtServiceEquipments: this.equipments,
        visualInfo: this.visualInfo,
        recentEvaluations:
          this.$refs.recentEvaluations != null
            ? this.$refs.recentEvaluations.evaluations
            : [],
      };
      this.$ApiPost(
        'api/atservice/savemedicalinformation',
        detailMedicalInformationATDTO
      ).then(() => {
        this.ShowToast(
          this.resources['R03200110'],
          this.resources['R03200109'],
          'success'
        );
      });
    },
    handleEvaluationsUpdated(addedList, excludedList) {
      this.avalaibleEvaluations = Array.from(excludedList);
      this.notExecutedEvaluations = Array.from(addedList);
    },
    evaluationsPredicateDisabled(evaluation) {
      return evaluation.disabled;
    },
    handleTherapiesUpdated(addedList, excludedList) {
      this.avalaibleTherapies = Array.from(excludedList);
      this.notExecutedTherapies = Array.from(addedList);
    },
    IsVisiblegetRecentEvaluations() {
      return !store.getters.SelectPreEvalAnswer;
    },
    canEditVisualInfo() {
      return (
        this.visualInfo.evaluationDateString == 'N/A' ||
        this.visualInfo.evaluationDateString == ''
      );
    },
    validRecordEvaluation() {
      this.notExecutedTherapies.forEach((therapy) => {
        if (therapy.documentAttachmentIds != null) {
          return false;
        }
      });
      return true;
    },
    validateReadMode() {
      if (!this.atCompletedFlag) {
        return;
      }
      const tags = ['input', 'button', 'textarea', 'select'];
      tags.forEach((tagName) => {
        const nodes = document
          .getElementById('Tab2')
          .getElementsByTagName(tagName);
        for (let i = 0; i < nodes.length; i++) {
          nodes[i].disabled = true;
          nodes[i].tabIndex = -1;

          if (tagName == 'button') {
            nodes[i].style.display = 'none';
          }
        }
      });
    },
    downloadEvaluation(documentId) {
      this.$ApiGet(`api/atservice/evaluation/document/${documentId}`)
        .then((response) => {
          if (response.data.content != null) {
            const byteChars = atob(response.data.content);
            const byteNumbers = new Array(byteChars.length);
            for (let i = 0; i < byteChars.length; i++) {
              byteNumbers[i] = byteChars.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], {
              type: response.data.contentType,
            });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = response.data.filename;
            link.click();
          }
        })
        .catch((err) => {
          this.response = err;
        });
    },
  },
  created() {},
  mounted() {
    this.peiAtServiceId =
      store.getters.SelectedAt !== undefined || store.getters.SelectedAt == null
        ? store.getters.SelectedAt
        : 0;
    this.getExecutedServiceandEvaluations();
    this.getNotExecutedEvaluation();
    this.getNotExecutedtherapies();
    this.getAvalaibleEvaluations();
    this.getAvalaibletherapies();
    this.getEquipments();
    this.getGeneralAtInformation();
    this.validateReadMode();
    this.Info = this.$attrs.Info;
    this.loadResources();
  },
  computed: {
    atCompletedFlag() {
      return store.getters.getAtCompleted;
    },
    ValidationTriggered() {
      return store.getters.getatValidationTriggered;
    },
    peiAtServiceId() {
      return store.getters.SelectedAt;
    },
  },
};
</script>

<style scoped>
@import '../../../assets/css/previousofat/tab2.css';
.headboard {
  background-color: #3f5b60;
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 1rem;
  color: #ffffff;
  border-radius: 5px 5px 0px 0px;
}
.table-W .row {
  padding: 12px 29px;
}
.table-W2 .headboard {
  padding: 19px;
}
.divider {
  border: 1px solid #d9e5df;
  height: 1px;
  width: 100%;
}
.list-enter,
.list-leave-to {
  display: none;
}
.list-enter-active,
.list-leave-active {
  transition: height 0.35s ease;
}
</style>
